<template>
  <el-row class="main-container">
    <el-col :span="18" :offset="3" class="main-content">
      <router-view :key="$route.fullPath"></router-view>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'main-body',
}
</script>

<style scoped>
.main-container {
  margin: 4px auto;
}
.main-content {
  background: white;
  overflow: scroll;
  min-height: 1000px;
  border-radius: 3px;
  padding: 10px 10px 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/MainBody.vue